const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://tb.eyecyber.com:443/api';
const deviceControlApiUrl = `${apiBaseUrl}/device/`;
const grafanaBaseUrl = process.env.REACT_APP_GRAFANA_BASE_URL || 'https://tb.eyecyber.com:18300';

export { apiBaseUrl, deviceControlApiUrl, grafanaBaseUrl };
